import React from "react";

/** Miniature SVG mockups of each biodata template.
 * Used as clickable cards in the template picker — hand-drawn to hint at the
 * layout the user will actually see in the live preview.
 */

const W = 160;
const H = 210; // roughly A4 aspect

function ClassicMini() {
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height="100%">
      <rect x="0" y="0" width={W} height={H} fill="#fdfbf7" />
      <rect x="6" y="6" width={W - 12} height={H - 12} fill="none" stroke="#8b1e41" strokeWidth="1.6" />
      <rect x="8" y="8" width={W - 16} height={H - 16} fill="none" stroke="#8b1e41" strokeWidth="0.6" />
      <text x={W / 2} y="24" textAnchor="middle" fontFamily="Georgia" fontSize="9" fill="#8b1e41" letterSpacing="1">॥ ॐ ॥</text>
      <text x={W / 2} y="42" textAnchor="middle" fontFamily="Georgia" fontWeight="700" fontSize="15" fill="#8b1e41" letterSpacing="3">BIODATA</text>
      <text x={W / 2} y="54" textAnchor="middle" fontSize="7" fill="#b8942f" letterSpacing="3">◆ ◆ ◆</text>
      {[70, 110, 150].map((y) => (
        <g key={y}>
          <text x="18" y={y} fontFamily="Georgia" fontSize="7" fontWeight="700" fill="#8b1e41" letterSpacing="1">SECTION</text>
          <line x1="18" y1={y + 3} x2={W - 18} y2={y + 3} stroke="#e5c98a" strokeWidth="0.5" />
          {[0, 1, 2, 3].map((i) => (
            <g key={i}>
              <line x1="20" y1={y + 12 + i * 7} x2="60" y2={y + 12 + i * 7} stroke="#4a4542" strokeWidth="0.6" />
              <line x1="70" y1={y + 12 + i * 7} x2={W - 18} y2={y + 12 + i * 7} stroke="#c9c1b5" strokeWidth="0.6" />
            </g>
          ))}
        </g>
      ))}
      <text x={W / 2} y={H - 12} textAnchor="middle" fontSize="7" fill="#b8942f" letterSpacing="3">✦ ✦ ✦</text>
    </svg>
  );
}

function ModernMini() {
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height="100%">
      <rect x="0" y="0" width={W} height={H} fill="#ffffff" />
      <rect x="16" y="18" width="26" height="34" fill="#eee6d6" rx="3" />
      <text x="48" y="24" fontSize="4.5" fill="#8b1e41" letterSpacing="1.5">MARRIAGE BIODATA</text>
      <text x="48" y="38" fontFamily="Helvetica" fontSize="10" fontWeight="300" fill="#1a1614">Riya Verma</text>
      <text x="48" y="46" fontSize="5" fill="#4a4542">Software Engineer · Pune</text>
      <line x1="16" y1="60" x2={W - 16} y2="60" stroke="#e5e0d8" strokeWidth="0.5" />
      {[72, 108, 144, 180].map((y) => (
        <g key={y}>
          <text x="16" y={y} fontSize="5" fill="#8b1e41" letterSpacing="1.5">PERSONAL</text>
          {[0, 1, 2, 3].map((i) => (
            <g key={i}>
              <text x="16" y={y + 8 + i * 5.5} fontSize="4" fill="#8a817c">DATE OF BIRTH</text>
              <line x1="72" y1={y + 8 + i * 5.5} x2={W - 16} y2={y + 8 + i * 5.5} stroke="#c9c1b5" strokeWidth="0.5" />
            </g>
          ))}
        </g>
      ))}
    </svg>
  );
}

function RoyalMini() {
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height="100%">
      <defs>
        <linearGradient id="goldFrame" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#d4af37" />
          <stop offset="50%" stopColor="#8b1e41" />
          <stop offset="100%" stopColor="#d4af37" />
        </linearGradient>
        <linearGradient id="goldTitle" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#8b1e41" />
          <stop offset="50%" stopColor="#d4af37" />
          <stop offset="100%" stopColor="#8b1e41" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width={W} height={H} fill="#fbf3e0" />
      <rect x="6" y="6" width={W - 12} height={H - 12} fill="#fdfbf7" stroke="url(#goldFrame)" strokeWidth="3" />
      <text x={W / 2} y="24" textAnchor="middle" fontSize="7" fill="#b8942f" letterSpacing="2">❁ ✿ ❁</text>
      <text x={W / 2} y="42" textAnchor="middle" fontFamily="Georgia" fontWeight="700" fontSize="16" fill="url(#goldTitle)" letterSpacing="4">BIODATA</text>
      <line x1="20" y1="54" x2={W - 20} y2="54" stroke="#d4af37" strokeWidth="0.6" />
      <rect x={W / 2 - 14} y="60" width="28" height="34" fill="#f5eddb" stroke="#d4af37" strokeWidth="1" />
      {[104, 150].map((y) => (
        <g key={y}>
          <text x="18" y={y} fontFamily="Georgia" fontSize="6" fontWeight="700" fill="#8b1e41" letterSpacing="1.2">PERSONAL</text>
          <text x={W / 2 + 4} y={y} fontFamily="Georgia" fontSize="6" fontWeight="700" fill="#8b1e41" letterSpacing="1.2">FAMILY</text>
          {[0, 1, 2, 3].map((i) => (
            <g key={i}>
              <line x1="18" y1={y + 6 + i * 5} x2={W / 2 - 6} y2={y + 6 + i * 5} stroke="#c9c1b5" strokeWidth="0.4" />
              <line x1={W / 2 + 4} y1={y + 6 + i * 5} x2={W - 18} y2={y + 6 + i * 5} stroke="#c9c1b5" strokeWidth="0.4" />
            </g>
          ))}
        </g>
      ))}
    </svg>
  );
}

const TEMPLATE_META = {
  classic: { title: "Classic Traditional", subtitle: "Serif · Om header · maroon border", accent: "#8b1e41", Mini: ClassicMini },
  modern:  { title: "Modern Minimal",       subtitle: "Sans-serif · photo-forward · airy", accent: "#4a4542", Mini: ModernMini  },
  royal:   { title: "Royal Ornate",         subtitle: "Gold gradient · dual-column · regal", accent: "#d4af37", Mini: RoyalMini   },
};

export default function TemplateThumbnails({ value, onChange, testIdPrefix = "template" }) {
  const ids = Object.keys(TEMPLATE_META);
  return (
    <div className="sb-template-grid" data-testid="template-thumbnails">
      {ids.map((id) => {
        const m = TEMPLATE_META[id];
        const active = value === id;
        return (
          <button
            type="button"
            key={id}
            className={"sb-template-card" + (active ? " active" : "")}
            onClick={() => onChange(id)}
            data-testid={`${testIdPrefix}-${id}`}
            aria-pressed={active}
          >
            <div className="sb-template-thumb">
              <m.Mini />
            </div>
            <div className="sb-template-meta">
              <div className="sb-template-title">{m.title}</div>
              <div className="sb-template-sub">{m.subtitle}</div>
            </div>
            {active && <span className="sb-template-tick">✓</span>}
          </button>
        );
      })}
    </div>
  );
}
